// FearGreedHistoryCalculator.js
// Static class — Noun.Verb methods, derives current/yesterday/lastWeek/lastMonth
// from the raw cached history. Business logic lives here, not in Fetcher or Engine.
import df from '../../../services/utils/DateFormat';

class FearGreedHistoryCalculator {
    /**
     * @param {{rk:string,value:number,class:string,ems:number}[]} items - raw cached history
     * @returns {object|null} current state incl. yesterday/lastWeek/lastMonth, or null if empty
     */
    static buildState(items) {
        if (!items?.length) return null;

        const sorted = [...items].sort((a, b) => Number(b.rk) - Number(a.rk));
        const current = sorted[0];
        const currentMs = Number(current.rk);
        const day = df.MillisecondsInDay;

        return {
            value: current.value,
            label: current.class,
            yesterday: FearGreedHistoryCalculator._closest(sorted, currentMs - day)?.value ?? null,
            lastWeek: FearGreedHistoryCalculator._closest(sorted, currentMs - day * 7)?.value ?? null,
            lastMonth: FearGreedHistoryCalculator._closest(sorted, currentMs - day * 30)?.value ?? null,
            lastUpdated: current.ems,
        };
    }

    /**
     * @param {object[]} sortedItems - sorted desc by rk
     * @param {number} targetMs
     * @returns {object|null} item whose rk is closest to targetMs
     */
    static _closest(sortedItems, targetMs) {
        return sortedItems.reduce((best, item) => {
            if (!best) return item;
            const diff = Math.abs(Number(item.rk) - targetMs);
            const bestDiff = Math.abs(Number(best.rk) - targetMs);
            return diff < bestDiff ? item : best;
        }, null);
    }

    /**
     * @param {{rk:string,value:number,class:string,ems:number}[]} items - raw cached history
     * @returns {object[]} chronological order (oldest first) for charting
     */
    static sortAscending(items) {
        if (!items?.length) return [];
        return [...items].sort((a, b) => Number(a.rk) - Number(b.rk));
    }
}

export default FearGreedHistoryCalculator;
